<template>
  <div>
    <div class="logo">
      <img src="@/assets/logo.png" v-show="!iscollapsed" />
      <img src="@/assets/logo-mini.png" v-show="iscollapsed" />
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :collapse="iscollapsed" :background-color="variables.menuBg"
        :active-text-color="variables.menuActiveText" :text-color="variables.menuText" :unique-opened="false"
        :collapse-transition="false" mode="vertical" :default-openeds="openeds" :default-active="$route.path"
        @select="select" router>
        <el-menu-item index="/index"> <i class="el-icon-house"></i> <span>系统首页</span> </el-menu-item>
        <el-menu-item index="/person/info"><i class="el-icon-user"></i><span>个人账号信息</span></el-menu-item>

        <template v-for="item in menus">
          <el-submenu v-if="item.children" :index="item.url" :key="item.name">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.title }} </span>
            </template>
            <el-menu-item v-for="item2 in item.children" :index="item2.url" :key="item2.name"> <i
                :class="item2.icon"></i> {{
              item2.title }}</el-menu-item>
          </el-submenu>

          <el-menu-item v-else :index="item.url" :key="item.name">
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
            <template v-if="item.name == 'receivedList'">
              <span class="badge" :ref="item.name + '_badge'">{{ financeStat.skCount }}</span>
            </template>
            <template v-else-if="item.name == 'refundList1'">
              <span class="badge" :ref="item.name + '_badge'">{{ financeStat.dtkCount }}</span>
            </template>
            <template v-else-if="item.name == 'refundList2'">
              <span class="badge" :ref="item.name + '_badge'">{{ financeStat.tkSbCount }}</span>
            </template>
            <template v-else-if="item.name == 'invoiceList1'">
              <span class="badge" :ref="item.name + '_badge'">{{ financeStat.dkfpCount + financeStat.kjfpzCount
                }}</span>
            </template>

            <template v-else-if="item.name == 'myArticleRunning'">
              <span class="badge primary" :ref="item.name + '_badge'">{{ authorStat.tgzGj }}</span>
            </template>
            <template v-else-if="item.name == 'myArticleReceive'">
              <span class="badge success" :ref="item.name + '_badge'">{{ authorStat.yslGj }}</span>
            </template>
            <template v-else-if="item.name == 'myArticleRejected'">
              <span class="badge" :ref="item.name + '_badge'">{{ authorStat.ytgGj }}</span>
            </template>

            <!--编辑人员-->
            <template v-else-if="item.name == 'editorArticlePool'">
              <span class="badge" :ref="item.name + '_badge'">{{ editorStat.gjc }}</span>
            </template>
            <template v-else-if="item.name == 'editorReviewAwaiting'">
              <span class="badge" :ref="item.name + '_badge'">{{ editorStat.dpsGj }}</span>
            </template>
            <template v-else-if="item.name == 'publishRegister'">
              <span class="badge" :ref="item.name + '_badge'">{{ editorStat.ddjBmfGj }}</span>
            </template>

            <!--专家人员-->
            <template v-else-if="item.name == 'exportArticlePool'">
              <span class="badge" :ref="item.name + '_badge'">{{ expertStat.gjc }}</span>
            </template>
            <template v-else-if="item.name == 'exportReviewAwaiting'">
              <span class="badge" :ref="item.name + '_badge'">{{ expertStat.dpsGj }}</span>
            </template>
            <template v-else-if="item.name == 'exportRviewFinished'">
              <span class="badge" :ref="item.name + '_badge'">{{ expertStat.ypsGj }}</span>
            </template>

            <template v-else-if="item.name == 'dc0'">
              <span class="badge" :ref="item.name + '_badge'">{{ recheckStat.dczGj }}</span>
            </template>
          </el-menu-item>
        </template>
        <!--el-menu-item index="/sys/version"><i class="el-icon-user"></i><span>版本说明</span></el-menu-item-->
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import variables from "@/styles/variables.scss"
import personApi from "@/api/person"
export default {
  name: "Sidebar",
  components: {},
  data() {
    return {
      activeIndex: "/",
      openeds: ["/"],
      menus: [],
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      menusData: {
        USER: [
          {
            name: "myArticleAdd",
            title: "立即投稿",
            url: "/article/add",
            icon: "el-icon-edit-outline",
            badge: -1,
          },
          {
            name: "myArticleRunning",
            title: "投稿中稿件",
            url: "/article/myArticleRunning",
            icon: "el-icon-notebook-2",
            badge: 0,
            type: "primary",
          },
          {
            name: "myArticleReceive",
            title: "已录用稿件",
            url: "/article/myArticleReceive",
            icon: "el-icon-folder-checked",
            badge: -1,
          },
          {
            name: "myArticleRejected",
            title: "被退稿稿件",
            url: "/article/myArticleRejected",
            icon: "el-icon-folder-delete",
            badge: -1,
          },
          {
            name: "myInvoiceList",
            title: "发票申请及记录",
            url: "/article/myInvoiceList",
            icon: "el-icon-bank-card",
            badge: -1,
          },
          {
            name: "myRefundList",
            title: "退款申请及记录",
            url: "/article/myRefundList",
            icon: "el-icon-bank-card",
            badge: -1,
          },
          {
            name: "myPayList",
            title: "支付记录",
            url: "/article/myPayList",
            icon: "el-icon-bank-card",
            badge: -1,
          },
        ],
        EDITOR: [
          {
            name: "editorArticlePool",
            title: "稿件池",
            url: "/editor/articlePool",
            icon: "el-icon-coin",
            badge: 0,
          },
          {
            name: "editorReviewAwaiting",
            title: "待审稿件",
            url: "/editor/reviewAwaiting",
            icon: "el-icon-notebook-2",
            badge: 0,
          },
          {
            name: "editorReviewFinished",
            title: "已审稿件",
            url: "/editor/reviewFinished",
            icon: "el-icon-tickets",
            badge: -1,
          },
          {
            name: "publishRegister",
            title: "待登记出版信息稿件",
            url: "/editor/publishRegister",
            icon: "el-icon-notebook-1",
            badge: 0,
          },
          {
            name: "publishFinshed",
            title: "已登记出版信息稿件",
            url: "/editor/publishFinshed",
            icon: "el-icon-document",
            badge: -1,
          },
          {
            name: "payment",
            title: "出版费缴纳情况查询",
            url: "/editor/payment",
            icon: "el-icon-search",
            badge: -1,
          },
          {
            name: "articleAccepted",
            title: "已录用稿件",
            url: "/editor/articleAccepted",
            icon: "el-icon-notebook-2",
            badge: -1,
          },
          {
            name: "remark",
            title: "审稿意见配置",
            url: "/editor/remark",
            icon: "el-icon-coin",
            badge: -1,
          },
        ],
        EXPERT: [
          {
            name: "exportArticlePool",
            title: "稿件池",
            url: "/expert/articlePool",
            icon: "el-icon-coin",
            badge: 0,
          },
          {
            name: "exportReviewAwaiting",
            title: "待审稿件",
            url: "/expert/reviewAwaiting",
            icon: "el-icon-notebook-2",
            badge: 0,
          },
          {
            name: "exportReviewFinished",
            title: "已审稿件",
            url: "/expert/reviewFinished",
            icon: "el-icon-tickets",
            badge: -1,
          },
          {
            name: "remark",
            title: "审稿意见配置",
            url: "/expert/remark",
            icon: "el-icon-coin",
            badge: -1,
          },
        ],
        ADMIN: [
          {
            name: "setting",
            title: "系统管理",
            url: "/admin/basic/layout",
            icon: "el-icon-setting",
            badge: -1,
            children: [
              {
                name: "setting",
                title: "系统配置",
                url: "/admin/basic/setting",
                icon: "el-icon-arrow-right",
                badge: -1,
              },
              {
                name: "adminUser",
                title: "管理员设置",
                url: "/admin/basic/adminUser",
                icon: "el-icon-arrow-right",
                badge: -1,
              },
              {
                name: "subject",
                title: (process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目") + "管理",
                url: "/admin/basic/subject",
                icon: "el-icon-arrow-right",
                badge: -1,
              },
              {
                name: "userList",
                title: "用户管理",
                url: "/admin/users/list",
                icon: "el-icon-arrow-right",
                badge: -1,
              },
              {
                name: "articleList",
                title: "稿件状态查询",
                url: "/admin/article/list",
                icon: "el-icon-arrow-right",
                badge: -1,
              },
            ],
          },
        ],
        RECHECK: [
          {
            name: "reportExpert",
            title: "专家审稿统计",
            url: "/recheck/reportExpert",
            icon: "el-icon-notebook-1",
            badge: -1,
          },
          {
            name: "dc0",
            title: "待查重稿件",
            url: "/recheck/dc0",
            icon: "el-icon-notebook-1",
            badge: 0,
          },

          {
            name: "dc1",
            title: "查重结果登记",
            url: "/recheck/dc1",
            icon: "el-icon-edit-outline",
            badge: -1,
          },
          {
            name: "dc2",
            title: "查重结果查询",
            url: "/recheck/dc2",
            icon: "el-icon-search",
            badge: -1,
          },
          {
            name: "dc-articleAccepted",
            title: "已录用稿件",
            url: "/recheck/articleAccepted",
            icon: "el-icon-notebook-2",
            badge: -1,
          },
        ],
        FINANCE: [
          {
            name: "receivedList",
            title: "收款记录",
            url: "/finance/receivedList",
            icon: "el-icon-notebook-1",
            badge: 0,
          },
          {
            name: "refundList1",
            title: "待退款记录",
            url: "/finance/refundList1",
            icon: "el-icon-edit-outline",
            badge: 0,
          },
          {
            name: "refundList2",
            title: "已处理退款记录",
            url: "/finance/refundList2",
            icon: "el-icon-edit-outline",
            badge: -1,
          },
          {
            name: "invoiceList1",
            title: "待开发票记录",
            url: "/finance/invoiceList1",
            icon: "el-icon-edit-outline",
            badge: 0,
          },
          {
            name: "invoiceList2",
            title: "已开发票记录",
            url: "/finance/invoiceList2",
            icon: "el-icon-edit-outline",
            badge: -1,
          },
          //{ name: "statistics", title: "财务统计", url: "/finance/statistics", icon: "el-icon-edit-outline", badge: -1 },
        ],
      },
    }
  },
  computed: {
    variables() {
      return variables
    },
    iscollapsed() {
      return !this.$store.state.app.sidebar.opened
    },
    authorStat() {
      return this.$store.state.app.authorStat
    },
    financeStat() {
      return this.$store.state.app.financeStat
    },
    editorStat() {
      return this.$store.state.app.editorStat
    },
    expertStat() {
      return this.$store.state.app.expertStat
    },
    recheckStat() {
      return this.$store.state.app.recheckStat
    },
  },

  watch: {
    "$store.state.user.roles"(newData) {
      this.menus = []
      newData.forEach((item) => {
        if (item.value == "USER") {
          this.menus = this.menus.concat(this.menusData.USER)
        } else if (item.value == "EDITOR") {
          this.menus = this.menus.concat(this.menusData.EDITOR)
        } else if (item.value == "EXPERT") {
          this.menus = this.menus.concat(this.menusData.EXPERT)
        } else if (item.value == "ADMIN") {
          this.menus = this.menus.concat(this.menusData.ADMIN)
        } else if (item.value == "RECHECK") {
          this.menus = this.menus.concat(this.menusData.RECHECK)
        } else if (item.value == "FINANCE") {
          this.menus = this.menus.concat(this.menusData.FINANCE)
        }
      })
    },
  },

  mounted() {
    this.loadUserInfo()
  },

  methods: {
    loadUserInfo() {
      personApi.getInfo().then((res) => {
        if (res.code == 0) {
          let name = res.data.userName == "" ? res.data.LoginName : res.data.userName

          this.$store.commit("user/SET_NAME", name)
          this.$store.commit("user/SET_ROLES", res.data.roles)

          //处理收费与否相关菜单
          if (!this.$config.siCharge) {

            this.menusData.USER = this.menusData.USER.filter((ele) => {
              return ele.name !== "myInvoiceList" && ele.name !== "myRefundList" && ele.name !== "myPayList"
            })

            this.menusData.EDITOR = this.menusData.EDITOR.filter((ele) => {
              return ele.name !== "payment"
            })
            
          }

          
        }
      })
    },

    select() {
      if (this.$store.state.app.device === "mobile") {
        this.$store.dispatch("app/toggleSideBar", { withoutAnimation: false })
      }
    },
  },
}
</script>
